import { css, Global } from '@emotion/react'
import { useLayoutEffect, useState } from 'react'

export const HS_CHAT_OPEN_HASH = '#hs-chat-open'

export const isHsChatOpenHash = (hash?: string | null) =>
  (hash ?? (typeof window !== 'undefined' ? window.location.hash : '')) === HS_CHAT_OPEN_HASH

/** Clears `#hs-chat-open` without adding a history entry. `replaceState` does not fire `hashchange`. */
export const clearHsChatOpenHash = () => {
  if (typeof window === 'undefined' || !isHsChatOpenHash()) {
    return
  }
  window.history.replaceState(null, '', `${window.location.pathname}${window.location.search}`)
  window.dispatchEvent(new Event('hashchange'))
}

export const useHsChatOpen = () => {
  const [hsChatOpen, setHsChatOpen] = useState(false)

  useLayoutEffect(() => {
    const sync = () => setHsChatOpen(isHsChatOpenHash(window.location.hash))
    sync()
    window.addEventListener('hashchange', sync)
    return () => window.removeEventListener('hashchange', sync)
  }, [])

  return hsChatOpen
}

const hubspotHideStyles = css`
  div#hubspot-messages-iframe-container {
    display: none !important;
  }
`

/** Hides the HubSpot chat widget unless the URL hash is `#hs-chat-open`. */
export const HubspotHideChatStyles = () => {
  const hsChatOpen = useHsChatOpen()
  const [canHide, setCanHide] = useState(false)

  useLayoutEffect(() => {
    setCanHide(true)
  }, [])

  if (!canHide || hsChatOpen) {
    return null
  }
  return <Global styles={hubspotHideStyles} />
}
